import { __decorate } from "tslib";
import ClosedReportDate from "@/components/ClosedReportDate.vue";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import ImpersonationButton from "@/components/ImpersonationButton.vue";
import Modal from "@/components/Modal.vue";
import CreateUserDialog from "@/components/Modals/CreateUserDialog.vue";
import UserTariffDialog from "@/components/Modals/UserTariffDialog.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import TeamList from "@/types/Team/TeamList";
import User from "@/types/User/User";
import UserList from "@/types/User/UserList";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
let InternsEditor = class InternsEditor extends Vue {
    isCurrentIntern(intern) {
        return (moment(new Date()) <= moment(intern.to) ||
            intern.to === null);
    }
    filterCurrentInterns() {
        if (this.$data.onlyCurrentInterns === true) {
            this.$data.filteredInterns = this.$data.interns.filter((intern) => {
                return this.isCurrentIntern(intern);
            });
        }
        else {
            this.$data.filteredInterns = this.$data.interns;
        }
    }
    //shows the external tariff modal to add tariffs for a intern
    showTariffModal(userItem) {
        this.$data.selectedIntern = userItem; // the refence used for the user in the component gets updated
        this.$data.showUserTariffDialog = true;
    }
    loadUserTariffs() {
        const userId = this.$data.selectedIntern.userId;
        this.$store
            .dispatch("adminGetUserTariffsAsync", userId)
            .then((result) => { })
            .catch((err) => {
            window.errorHandler.logError(err, "components/InternsEditor.vue - loadUserTariffs");
        });
    }
    // private loadGlobalTariffs() {
    //   this.$store
    //     .dispatch("loadGlobalTariffsAsync")
    //     .then((result: any) => {
    //       this.$data.globalTariffs = result.data;
    //     })
    //     .catch((err: any) => {
    //       (window as any).errorHandler.logError(
    //         err,
    //         "components/InternsEditor.vue - loadInterns"
    //       );
    //     });
    // }
    updateCreateUser(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "createUserDialog")
        this.$data.showCreateUserDialog = value;
    }
    updateEditIntern(value) {
        //recieve the event from the child to determine if we should close the modal (part of the "editInternDialog")
        this.$data.modals.editIntern = value;
    }
    closeAddModal() {
        this.$data.selectedUserToAdd = null;
        this.$data.selectedTeamToAddTo = null;
        this.$data.userList = null;
        this.$data.teamList = null;
        this.$data.modals.addinternModal = false;
    }
    loadInterns() {
        this.$data.interns = null;
        this.$store
            .dispatch("getAdminInterns")
            .then((result) => {
            this.$data.interns = result.data;
            this.filterCurrentInterns();
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/InternsEditor.vue - loadInterns");
        });
    }
    loadUsers() {
        this.$data.loadingUsers = true;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.loadingUsers = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/InternsEditor.vue - loadUsers");
        });
    }
    showAddModal() {
        this.loadUsers();
        //clear the selected data before we show the dialog
        (this.$data.selectedUserToAdd = null),
            (this.$data.createInternDates = { from: null, to: null });
        //show create dialog
        this.$data.modals.addinternModal = true;
    }
    loadTeams() {
        this.$data.loadingTeams = true;
        this.$store
            .dispatch("adminLoadTeamsAsync")
            .then((result) => {
            this.$data.teamList = new TeamList(result.data);
            this.$data.loadingTeams = false;
            console.log(this.$data.teamList);
        })
            .catch((err) => {
            this.$data.loadingTeams = false;
            window.errorHandler.logError(err, "components/IntersEditor.vue -> loadTeams");
        });
    }
    addIntern() {
        //assign the dates to the intern
        this.$data.selectedUserToAdd.from = this.$data.createInternDates.from;
        this.$data.selectedUserToAdd.to = this.$data.createInternDates.to;
        //first we create an intern with their userId
        this.$store
            .dispatch("addAdminIntern", this.$data.selectedUserToAdd)
            .then((result) => {
            this.loadInterns();
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/IntersEditor.vue -> addAdminIntern");
        });
    }
    //shows the edit modal
    showEditModal(item) {
        this.$data.selectedIntern = item; //sets the selected user before opening the edit modal
        this.$data.modals.editIntern = true;
    }
    updateIntern() {
        this.$store
            .dispatch("updateAdminIntern", this.$data.selectedIntern)
            .then((result) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The intern " +
                    this.$data.selectedIntern.firstName +
                    " " +
                    this.$data.selectedIntern.lastName +
                    " has been updated",
            });
            this.$data.modals.editIntern = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/IntersEditor.vue -> updateIntern");
            this.$data.modals.editIntern = false;
        });
    }
    shortDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    impersonateUser(userItem) {
        //Retrieve the user object
        this.$store
            .dispatch("getUser", userItem.userId)
            .then((result) => {
            const impersonateUser = new User(userItem);
            this.$store.dispatch("impersonateUser", impersonateUser);
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/IntersEditor.vue -> impersonateUser");
        });
    }
};
InternsEditor = __decorate([
    Component({
        props: ["impUsers"],
        data() {
            return {
                theme: this.$store.getters.getTheme,
                filter: "",
                interns: null,
                filteredInterns: null,
                onlyCurrentInterns: true,
                modals: { addinternModal: false, editIntern: false },
                sortbyValue: "email",
                internHeaders: [
                    { text: "Name", value: "email", divider: true },
                    {
                        text: "Closed Reports",
                        value: "closedReportsDate",
                        align: "center",
                        divider: true,
                    },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Tariffs", value: "tariffs", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                ],
                selectedIntern: null,
                userList: null,
                teamList: null,
                loadingUsers: false,
                loadingTeams: false,
                selectedUserToAdd: null,
                selectedTeamToAddTo: null,
                showCreateUserDialog: false,
                showUserTariffDialog: false,
                createInternDates: { from: null, to: null },
                internTariffs: null,
                globalTariffs: null,
            };
        },
        created() {
            this.loadInterns();
        },
        components: {
            ClosedReportDate,
            WhiteBox,
            Modal,
            CreateUserDialog,
            UserTariffDialog,
            ImpersonationButton,
            DatePickerTextbox,
        },
    })
], InternsEditor);
export default InternsEditor;
